export const CHAVE_MOSTRAR_NUMERO = 'chat-cabecalho-mostrar-numero';
